<template>
    <div>
        <navbar></navbar>
        <div class="__academybg">
            <div class="container">
                <div class="row">

                    <div class="col-lg-9 col-md-9 col-sm-9">
                        <p class="__welf1">Findworka academy is now <a href="https://jointechcampus.com/" target="_blank">Techcampus!</a></p>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-lg-7 col-md-7 col-sm-7">
                        <p class="__welf2">
                        The rebranding of Findworka academy into Techcampus is part of our renewed push as a firm believer in Africa and the role of talents as a vital pillar in building great tech ecosystems.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row _overlay-cards">
                <div class="col-lg-3 col-md-3 col-sm-6">
                    <a href="https://jointechcampus.com/frontend" target="_blank">
                        <div class="__impcard">
                            <div class="__impimg __codeimg"></div>
                            <div class="__imppc">
                                <p class="__impp">Frontend Development</p>
                                <p class="__impp1">
                                Become a frontend <br>developer today</p>
                                <p class="__imppa">
                                Get started &nbsp;&nbsp;<img
                                    alt="right arrow"
                                    src="../assets/img/right-arrow.svg"
                                />
                                </p>
                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-6">
                    <a href="https://jointechcampus.com/backend" target="_blank">
                        <div class="__impcard">
                        <div class="__impimg __robotimg"></div>
                        <div class="__imppc">
                            <p class="__impp">Backend Development</p>
                            <p class="__impp1">
                            Learn how to build great backend.
                            </p>
                            <p class="__imppa">
                            Get started &nbsp;&nbsp;<img
                                alt="right arrow"
                                src="../assets/img/right-arrow.svg"
                            />
                            </p>
                        </div></div
                    ></a>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-6">
                    <a href="https://jointechcampus.com/mobile" target="_blank">
                        <div class="__impcard">
                            <div class="__impimg __phoneimg"></div>
                            <div class="__imppc">
                                <p class="__impp">Mobile development</p>
                                <p class="__impp1">Learn how to build native and hybrid apps.</p>
                                <p class="__imppa">
                                Get started &nbsp;&nbsp;<img
                                    alt="right arrow"
                                    src="../assets/img/right-arrow.svg"
                                />
                                </p>
                            </div>
                        </div>
                    </a>
                </div>

                
                <div class="col-lg-3 col-md-3 col-sm-6">
                    <a href="https://jointechcampus.com/product" target="_blank">
                        <div class="__impcard">
                        <div class="__impimg __demoimg"></div>
                        <div class="__imppc">
                            <p class="__impp">Product design (UI/UX)</p>
                            <p class="__impp1">
                            Learn how to design beautiful apps and web pages.
                            </p>
                            <p class="__imppa">
                            Get started &nbsp;&nbsp;<img
                                alt="right arrow"
                                src="../assets/img/right-arrow.svg"
                            />
                            </p>
                        </div></div></a>
                </div>
            </div><br><br>
            <div class="text-center">
                <a href="https://jointechcampus.com/" target="_blank" class="btn __linkbtn">View all courses</a>
            </div>
        </div><br><br>
            <!-- <div class="text-center">
                <a href="https://academy.findworka.com/" target="blank" class="btn __linkbtn">Join our online classes for free</a>
            </div> -->
    

        <div class="container">
            <div class="row pd-round">
                <p class="__hirep">
                You are in the right place
                </p>
                <p class="__hirep1">
                What some of our students have to say
                </p>
                <carousel
                class="__slidtop __adjustslider"
                :autoplay="false"
                :nav="true"
                :items="3"
                :autoplayHoverPause="true"
                :dots="false"
                :margin="15"
                :loop="true"
                :autoplayTimeout="2000"
                :responsive="{
                    0: { items: 1, nav: false },
                    600: { items: 3, nav: false },
                    1024: { items: 3, nav: true }
                }"
                >
                <div class="__tescard">
                    <p class="__tesp">
                    Findworka Academy was not just a learning place for me, we were a tech family with members willing to help each other grow and learn. I'm really glad I attended. 
                    </p>
                    <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        <img src="../assets/img/chuck-academy.jpg" class="__tesimg" />
                    </div>
                    <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                        <p class="__tesp1">Chukwudi Udeh</p>

                        <p class="__tesp2">DevOps Engineer</p>
                    </div>
                    </div>
                </div>
                <div class="__tescard1">
                    <p class="__tesp">
                    I used to be skeptical about coding, but not anymore. Thanks to the Findworka Academy, I know now that anyone can code and I'm really excited about learning more!
                    </p>
                    <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        <img src="../assets/img/Temilayo-academy.jpg" class="__tesimg" />
                    </div>
                    <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                        <p class="__tesp1">Temilayo Subair</p>

                        <p class="__tesp2">Frontend Developer</p>
                    </div>
                    </div>
                </div>
                <div class="__tescard2">
                    <p class="__tesp">
                    My designs have gotten better and this is thanks to my time at the Findworka academy. Being mentored by some of the best product designers in our tech space has given me the edge and confidence. 
                    </p>
                    <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                        <img src="../assets/img/sola-academy.jpg" class="__tesimg" />
                    </div>
                    <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                        <p class="__tesp1">Olusola Oguniran</p>

                        <p class="__tesp2">Backend Developer</p>
                    </div>
                    </div>
                </div>
                </carousel>
            </div>
        </div>

        <div class="container">
            <div class="row pd-round">
                <p class="__hirep">
                Still not sure on what to do?
                </p>
                <p class="__hirep1">
                We are here to help you make the right decision
                </p>


                <a href="mailto:info@findworka.com" target="_blank" class="btn __linkbtn __adjustlink ">Contact us</a>
            </div>
        </div>
    </div>
</template>

<script>
import navbar from '../components/navbar';
import carousel from 'vue-owl-carousel';


export default {
    components: { carousel,
    navbar,
    },
}
</script>

<style scoped>
@import '../assets/css/academy';
</style>



// WEBPACK FOOTER //
// src/components/academy.vue